import React from "react";
import { Flex, Text } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import LabelTextComponent from "../LabelTextComponent";
import Constants from "../../../constants/text-constants";
import CallIDTextWithButton from "../../molecules/CallIDTextWithButton";
import TimerContainer from "../TimerContainer";
import AssistanceButton from "../AssistanceButton";
import { useMst } from "../../../hooks/useMst";

const CallDetails = observer((props) => {
  const { currentUser, showAlert, dismissAlert } = props;

  let { permissionStore } = useMst();

  const hasPermissionsAgent = permissionStore.havePermissions("Agent", [
    "Clear"
  ]);

  const hasPermissionsCallManager = permissionStore.havePermissions( "Call Manager", [
    "Assistance"
  ]);

  const assistanceButton = hasPermissionsAgent && hasPermissionsCallManager ? (
    <AssistanceButton agentId={currentUser.agent.id} alertDate={currentUser.agent.alertTime} showAlert={showAlert} dismissAlert={dismissAlert} />
  ) : null;

  return (
    <Flex
      gap="gap.large"
      className="call-details-container"
      data-testid="callDetails"
      column
    >
      <Flex gap="gap.large">
        <Flex className="half-width">
          <LabelTextComponent
            label={Constants.CALL_DETS_DESC_DIRECTION}
            text={
              currentUser.agent.getIsInOutboundCall()
                ? Constants.CALL_DETS_DETS_OUTBOUND
                : Constants.CALL_DETS_DETS_INBOUND
            }
            testId="callDetailsDirection"
          />
        </Flex>
        <Flex gap="gap.smaller" column className="half-width">
          <LabelTextComponent
            label={Constants.CALL_DETS_DESC_CALL_INFO}
            text={currentUser.agent.applicationDescription}
            testId="callDetailsCallInfo"
          />
          <Text
            className="call-details-text"
            content={currentUser.agent.queueDescription}
            data-testid={"callDetailsQueueDescription"}
          />
        </Flex>
      </Flex>
      <Flex gap="gap.large">
        <Flex className="half-width">
          <TimerContainer
            description={Constants.CALL_DETS_DESC_DURATION}
            startTime={currentUser.agent.statusChangeTime}
            testId="timerContainer"
          />
        </Flex>
        <Flex className="half-width">
          <LabelTextComponent
            label={Constants.CALL_DETS_DESC_TEAM_INFO}
            text={
              currentUser.agent.currentCallTeam
                ? currentUser.agent.currentCallTeam.name
                : ""
            }
            testId="callDetailsTeamInfo"
          />
        </Flex>
      </Flex>
      <Flex gap="gap.large">
        <Flex className="half-width">
          <LabelTextComponent
            label={
              currentUser.agent.getIsInOutboundCall()
                ? Constants.CALL_DETS_DESC_DIALLED_NUM
                : Constants.CALL_DETS_DESC_CALLER
            }
            text={currentUser.agent.currentCallCli}
            testId="callDetailsNumber"
          />
        </Flex>
        <Flex className="half-width">
          <CallIDTextWithButton
            label={Constants.CALL_DETS_DESC_REFERENCE_ID}
            text={currentUser.agent.callReference}
            testId="callDetailsReferenceID"
        />
        </Flex>
      </Flex>
      <Flex vAlign="center" hAlign="center">
          {assistanceButton}
        </Flex>
    </Flex>
  );
});

CallDetails.propTypes = {
  currentUser: PropTypes.object,
};

CallDetails.defaultProps = {
  currentUser: {},
};

export default CallDetails;
